/**
 * Reads the current value from a native input event. Pluma text inputs emit a native `input` event
 * (not React's synthetic `onChange`), so handlers read the value off the event target at runtime.
 * Returns an empty string when the target isn't an input element.
 */
export function readInputValue(event: Event): string {
  return event.target instanceof HTMLInputElement ? event.target.value : '';
}
